import { FC, useCallback, useEffect } from 'react';

import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, rem } from '@bonusly/design-system';

import { Announcement } from '../../types/announcements';
import { AnnouncementCard } from '../announcement-card';

interface AnnouncementsCarouselModalProps {
	announcements: Announcement[];
	currentIndex: number;
	isOpen: boolean;
	onClose: () => void;
	onNavigate: (index: number) => void;
}

export const AnnouncementsCarouselModal: FC<AnnouncementsCarouselModalProps> = ({ announcements, currentIndex, isOpen, onClose, onNavigate }) => {
	const announcement = announcements[currentIndex];

	const handleKeyDown = useCallback(
		(e: KeyboardEvent) => {
			if (e.key === 'ArrowLeft' && currentIndex > 0) {
				onNavigate(currentIndex - 1);
			} else if (e.key === 'ArrowRight' && currentIndex < announcements.length - 1) {
				onNavigate(currentIndex + 1);
			}
		},
		[currentIndex, announcements.length, onNavigate]
	);

	// Global listener needed because trapFocus={false} allows focus outside the modal
	useEffect(() => {
		if (!isOpen) return;
		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [isOpen, handleKeyDown]);

	if (!announcement) return null;

	return (
		<Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', sm: '2xl' }} trapFocus={false}>
			<ModalOverlay />
			<ModalContent bg="bg.surface">
				<ModalCloseButton size="md" borderRadius="full" />
				<ModalBody px={rem(20)} py={rem(16)}>
					<AnnouncementCard announcement={announcement} />
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
